module.exports = __webpack_public_path__ + "img/icon_production_hk.cc3c1ee8.png";